import { render, staticRenderFns } from "./BlockListSpotBox.vue?vue&type=template&id=38f181b2&"
import script from "./BlockListSpotBox.vue?vue&type=script&lang=js&"
export * from "./BlockListSpotBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports